import { createContext } from 'react';

const SymbolContext = createContext({
  symbols: [],
});

export { SymbolContext };
